import * as React from 'react';
import { Book } from '../../types/Book';
import { CollectionShort } from '../../types/Collection';
import Select, { Item } from '../Select/Select';
import './PeekCategory.css';
import Button from '../Button/Button';
import { API_URL } from '../../utils';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
	book: Book;
	categories: CollectionShort[];
}

const PeekCategory: React.FC<Props> = ({ book, categories }) => {
	const [selected, setSelected] = React.useState(null);
	const [loading, setLoading] = React.useState(false);

	const request = async () => {
		const data = await fetch(`${API_URL}/books/peekCategory?bookId=${book.woo_id}&categoryId=${selected}`, {
			credentials: 'include'
		});

		return await data.json();
	};

	const onSave = () => {
		setLoading(true);

		request().then(data => {
			if (data) {
				window.location.reload();
			}
		});
	};

	const categoriesList: Item[] = React.useMemo(() => {
		return categories.map(item => {
			return {
				value: item.id.toString(),
				label: item.name
			}
		})
	}, [categories]);

	return (
		<div className="peekCategory">
			{loading && (
				<div className="peekCategory__loader">
					<CircularProgress />
				</div>
			)}

			{!loading && (
				<>
					<div className="peekCategory__header">
						У этой книги пока нет категории. Вы можете ее указать
					</div>

					<Select
						items={categoriesList}
						onChange={(e) => setSelected(e.target.value)}
						label="Выберите категорию"
					/>

					{selected && (
						<Button
							className="peekCategory__save"
							type="primary"
							isLoading={loading}
							onClick={onSave}
						>
							Сохранить
						</Button>
					)}
				</>
			)}
		</div>
	);
};

export default PeekCategory;
